//import 'react-toastify/dist/ReactToastify.css';
//import "primereact/resources/themes/lara-light-cyan/theme.css";

// Straight Exports
export {createRoot} from 'react-dom/client'

export {
    createElement
   ,createContext
   ,useEffect
   ,useReducer
   ,useContext
   ,useCallback
   ,useRef
   ,useMemo
   ,useState
   ,createRef
} from 'react'

export type {
    FC,
    PropsWithChildren,
    ComponentPropsWithRef,
    RefObject,
    FunctionComponent,
    Component,
    ReactNode,
    HTMLAttributes,
    CSSProperties,
    MouseEventHandler,
    ChangeEventHandler
} from 'react'

import queryString from 'query-string'

const {stringify: stringifyQueryString, parse: parseQueryString} = queryString

export {stringifyQueryString, parseQueryString}

export {
    useParams
   ,useNavigate
   ,useLocation
   ,useSearchParams
   ,BrowserRouter
   ,Outlet
   ,Route
   ,Routes
   ,Link
   ,matchPath
   ,generatePath
   ,useMatch
   ,Navigate
} from 'react-router-dom'

export type {RouteProps, RouterProps, PathMatch, PathPattern, Path} from 'react-router-dom'

export {
    Button
   ,Card
   ,Alert
   ,Modal
   ,Col
   ,Form
   ,Row
   ,Image
   ,Dropdown
   ,Badge
   ,Accordion
   ,Tabs
   ,Tab
   ,Table
} from 'react-bootstrap'

export type {ButtonProps} from 'react-bootstrap'
export type { FormCheckType } from 'react-bootstrap/esm/FormCheck'

export {
    ToastContainer,
    toast
} from 'react-toastify'


export {default as JoditEditor} from 'jodit-react'

export { PrimeReactProvider } from 'primereact/api'


//export { Provider as ReduxProvider } from 'react-redux';

export {default as Swal} from 'sweetalert2';

export type {SweetAlertOptions} from 'sweetalert2'


// Forwards
